// @To-Do: Extract to shared library (https://nitrexgroup.atlassian.net/browse/QMU-5093)
import {
  ELanguage,
} from '@qmulus/frontend-shared/type/locale.ts';

export function getDefaultLanguage(): ELanguage {
  if (navigator.language.startsWith('sk')) {
    return ELanguage.SK;
  }
  if (navigator.language.startsWith('pl')) {
    return ELanguage.PL;
  }
  if (navigator.language.startsWith('de')) {
    return ELanguage.DE;
  }
  return navigator.language.startsWith('en-US') ? ELanguage.EN_US : ELanguage.EN_GB;
}
